import { Component, EventEmitter, OnInit, Input, Output, ViewChild, forwardRef} from '@angular/core';
import { EmailValidator, FormBuilder, FormGroup, Validators, FormArray } from '@angular/forms';
import {Message, OverlayPanel, SelectItem} from 'primeng/primeng';

//constants

//validators
import { dropDownValidator }                from '../../validators/CustomValidators';
import { hiddenDropDownValueValidator }                from '../../validators/CustomValidators';

import * as ent from '../../entities/index'
import * as filters from '../../filters/index'
import * as enums from '../../enums/index'

//components
import {CoolerLineItemGridComponent} from '../../components/Grids/CoolerLineItemGrid.component';
import {ProductSizeMultiSelectComponent} from '../../components/DomainData/ProductSizeMultiSelect.component';

//constants
import { Constants }         from '../../constants/Constants';

//base
import { BaseControlGroupComponent }         from '../../baseclasses/BaseControlGroup.component';

@Component({
  selector: 'my-coolerdetails',
  templateUrl: './CoolerDetails.component.html',
  providers: [{provide: BaseControlGroupComponent, useExisting: forwardRef(() => CoolerDetailsComponent)}]
})
export class CoolerDetailsComponent extends BaseControlGroupComponent {

    @ViewChild(CoolerLineItemGridComponent) public coolerLineItemGrid: CoolerLineItemGridComponent;
    @ViewChild(ProductSizeMultiSelectComponent) public productSizeMultiSelectComponent: ProductSizeMultiSelectComponent;
    
    coolerInfo: ent.CoolerInfo = new ent.CoolerInfo();
    removeReasonFilter: filters.ActivityReasonFilter;
    installReasonFilter: filters.ActivityReasonFilter;

    coolerDetailsForm: FormGroup;

    @Input() public showProjectedVolume: boolean;
    
    @Input() public requestTypeID: number;
    @Input() public showRemoveReason: boolean;
    @Input() public showInstallReason: boolean;
    @Input() public requireAccessories: boolean;
    @Input() public requireDimensions: boolean;
    @Input() public requireProjectedVolume: boolean;
  
    setRequestInfo(request: ent.Request){
        this.productSizeMultiSelectComponent.selectedIDs = [];
        this.coolerInfo = request.CoolerInfo;
        this.coolerLineItemGrid.lineItems = request.CoolerLineItems;

        if (request.RequestProductSizes){
            for (var requestProductSize of request.RequestProductSizes){
                this.productSizeMultiSelectComponent.selectedIDs.push(requestProductSize.ProductSizeID);
            }
        }
    }
    
    setDates(){}
    
    constructor(fb: FormBuilder) 
    { 
        super();
        this.removeReasonFilter = {RequestTypeID: this.requestTypeID, EquipmentClassID: enums.EquipmentClassEnum.Cooler, EquipmentActivityID: enums.EquipmentActivityEnum.Remove};
        this.installReasonFilter = {RequestTypeID: this.requestTypeID, EquipmentClassID: enums.EquipmentClassEnum.Cooler, EquipmentActivityID: enums.EquipmentActivityEnum.Install};
        let group = {
            'removeReason' : '',
            'installReason' : '',
            'accessories' : '',
            'spaceConstraints' : '',
            'dimensions' : '',
            'height' : '',
            'width' : '',
            'depth' : '',
            'casters' : '',
            'glides' : '',
            'locks' : '',
            'shelfDirection' : '',
            'hidShelfDirection' : '',
            'productSizes' : '',
            'glideType' : '',
            'hidGlideType' : '',
            'projectedVolume' : ''
        };
        
        this.coolerDetailsForm = fb.group(group);

    }


    ngOnInit(): void {

        if(this.requireAccessories) {
            this.coolerDetailsForm.controls['accessories'].setValidators(Validators.required);
        }

        if(this.requireDimensions) {
          this.coolerDetailsForm.controls['dimensions'].setValidators(Validators.required);
        }

        if(this.requireProjectedVolume) {
            this.coolerDetailsForm.controls['projectedVolume'].setValidators(Validators.required);
          }
    }

    removeReasonChange(event: any){
        this.coolerInfo.RemoveReasonID = event;
    }

    installReasonChange(event: any){
        this.coolerInfo.InstallReasonID = event;
    }

    shelfDirectionSelected(){
        var val = true;
        var form = this.coolerDetailsForm;
        if (form.controls.shelfDirection.errors && form.controls.hidShelfDirection.errors){
            if (form.controls.shelfDirection.errors.invalid && form.controls.hidShelfDirection.errors.invalid){
                val = false;
            }
        }
        return val;
    }

    shelfDirectionChange(event: any){
        this.coolerInfo.ShelfDirectionID = event;
    }

    glideTypeSelected(){
        var val = true;
        var form = this.coolerDetailsForm;
        if (form.controls.glideType.errors && form.controls.hidGlideType.errors){
            if (form.controls.glideType.errors.invalid && form.controls.hidGlideType.errors.invalid){
                val = false;
            }
        }
        return val;
    }

    glideTypeChange(event: any){
        this.coolerInfo.GlideTypeID = event;
    }

    onLineItemsChanged(event: number){
        this.coolerDetailsForm.controls['removeReason'].clearValidators();
        this.coolerDetailsForm.controls['installReason'].clearValidators();
        if (event > 0){
            if (this.showRemoveReason){
                this.coolerDetailsForm.controls['removeReason'].setValidators(Validators.required);
            }
            if (this.showInstallReason){
                this.coolerDetailsForm.controls['installReason'].setValidators(Validators.required);
            }
        }
        this.coolerDetailsForm.controls['removeReason'].updateValueAndValidity()
        this.coolerDetailsForm.controls['installReason'].updateValueAndValidity()
    }
}
